/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".without-br[_ngcontent-%COMP%]{white-space:nowrap}.right-float[_ngcontent-%COMP%]{float:right}.left-float[_ngcontent-%COMP%]{float:left}.status-action-plan[_ngcontent-%COMP%]{background-color:#a8d08d;font-style:normal;font-size:x-large;font-weight:700}.labe-bold[_ngcontent-%COMP%]{font-weight:700}.skin-reject[_ngcontent-%COMP%]{background-color:#ffc404;font-style:normal;font-size:x-large;font-weight:700}.div-container[_ngcontent-%COMP%]{padding:3% 4%}"];
export { styles as styles };
